import { EquipmentApi } from './adminAddEquipApi';
import { CatalogHierarchyService } from '../../../shared/service/catalogHierarchyService';

// Seleção hierárquica
function getCategorias() {
  return CatalogHierarchyService.getCategorias();
}

function getProdutosByCategoria(categoriaId) {
  return CatalogHierarchyService.getProdutosByCategoria(categoriaId);
}

function getServicosByProduto(produtoId) {
  return CatalogHierarchyService.getServicosByProduto(produtoId);
}

function loadEquipment(id) {
  return EquipmentApi.getById(id).then(r => r.data);
}

function saveEquipment(data, id = null) {
  return id
    ? EquipmentApi.update(id, data).then(r => r.data)
    : EquipmentApi.create(data).then(r => r.data);
}

/* FOTOS */

function uploadPhoto(equipId, momento, file) {
  const form = new FormData();
  form.append('equipamento_id', equipId);
  form.append('momento', momento);
  form.append('foto', file);
  return EquipmentApi.uploadPhoto(form).then(r => r.data);
}

function deletePhoto(id) {
  return EquipmentApi.deletePhoto(id).then(r => r.data);
}

/* LAUDOS */

function uploadLaudo(equipId, nome, file) {
  const form = new FormData();
  form.append('equipamento_id', equipId);
  form.append('nome', nome);
  form.append('laudo', file);
  return EquipmentApi.uploadLaudo(form).then(r => r.data);
}

function deleteLaudo(id) {
  return EquipmentApi.deleteLaudo(id).then(r => r.data);
}

export const EquipmentService = {
  getCategorias,
  getProdutosByCategoria,
  getServicosByProduto,
  loadEquipment,
  saveEquipment,
  uploadPhoto,
  deletePhoto,
  uploadLaudo,
  deleteLaudo
};